<!-- Body -->
<div class="ui basic segment">
    <app-header [title]="title" [back]="true"></app-header>
    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <deprecated-app-task-template-form
                    #taskTemplateForm
                    [taskTemplate]="taskTemplate"
                ></deprecated-app-task-template-form>
            </div>
            <div class="action-buttons">
                <ui-button url="..">{{ 'cancel' | translate }} </ui-button>
                <ui-button (click)="save(taskTemplateForm)" type="primary">{{ 'save' | translate }} </ui-button>
            </div>
        </div>

        <div class="sidebar">
            <div class="ui segment">
                <h3 class="text-color">{{ 'employees.settingsOffboarding.globalTasks' | translate }}</h3>
                <p>{{ 'employees.settingsOffboarding.savedAsATemplate' | translate }}</p>
                <p>{{ 'employees.settingsOffboarding.dueDate' | translate }}</p>
                <p>
                    <a
                        (click)="
                            analytics.logLinkOpen(
                                'https://humi.zendesk.com/hc/en-us/articles/360048623254',
                                events.OffboardingTaskLearnMore
                            )
                        "
                        >{{ 'employees.settingsOffboarding.learnMore' | translate }}</a
                    >{{ 'employees.settingsOffboarding.aboutTasks' | translate }}
                </p>
            </div>
        </div>
    </div>
</div>
